const imgify = (contentBody: any, apiUrl: string, classNames: string) => {
  const processed = contentBody
    .replace(/src="\/uploads/g, `src="${apiUrl}/uploads`)
    .replace(/<img /g, `<img class="${classNames}" `);

  return processed;
};

export default imgify;
